export enum AllyaUserSettings {
  numberOfPeriodsKey = 'numberOfPeriodsKey',
  projectAutoColWidthKey = 'projectAutoColWidthKey',
  resourceAutoColWidthKey = 'resourceAutoColWidthKey'
}
